var _style, _defs, _path, _g, _polygon, _polygon2, _path2, _polygon3, _polygon4, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _defs2, _g3, _defs3, _path9, _g4, _g5, _path10, _g6, _g7, _g8, _g9, _g10, _g11, _path11, _path12, _path13, _path14, _path15, _path16, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path17, _rect, _polygon5, _polygon6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShipOnTheSea = function SvgShipOnTheSea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1061 275.5",
    xmlSpace: "preserve",
    className: "SearchCategories__PlaceHolderImage-sc-1jrg13v-4 hKYqPi",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.37;clip-path:url(#SVGID_2_);fill:#CCE7F9;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#86C7EE;}\n\t.st3{fill:#1F3C74;}\n\t.st4{fill:#197BBF;}\n\t.st5{fill:#93C6EC;}\n\t.st6{fill:#B3DDE5;}\n\t.st7{fill:#373848;}\n\t.st8{fill:#CCE7F9;}\n\t.st9{fill:#F7E130;}\n\t.st10{opacity:0.34;}\n\t.st11{fill:none;stroke:#197BBF;stroke-width:0.1992;stroke-miterlimit:10;}\n\t.st12{clip-path:url(#SVGID_2_);fill:#CCE7F9;}\n\t.st13{clip-path:url(#SVGID_2_);fill:url(#SVGID_7_);}\n\t.st14{clip-path:url(#SVGID_2_);fill:url(#SVGID_8_);}\n\t.st15{clip-path:url(#SVGID_2_);fill:url(#SVGID_9_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1061,
    height: 275.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-18,153c0,0,40.5-82.4,195.3-17.7s131.5-69.1,392-10.2s491.8-39,491.8-39v151.5H-18V153z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "260.5,126.2 259.3,111.9 255.4,112.2 256.7,126.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "243.9,164 241.7,137.3 234.5,137.9 237.2,127.2 241.2,126.9 244.2,134.8 247.3,135 249.7,163.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "249.7,163.2 247.3,135 239.8,135.6 241.2,126.9 278.8,125.4 279.4,132.3 258.1,162.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "245.9,129.6 275.5,127.8 275.8,131.2 246.2,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "345.3,133.2 304.4,135.1 257.2,151.6 257.4,154.6 345.4,134.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "303.3,121.6 279.3,131.3 280.3,143.5 304.4,135.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "301,133.7 301.9,133.4 301.2,125.4 300.4,125.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "297.8,134.9 298.7,134.6 298,126.6 297.2,126.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.6,136.1 295.5,135.8 294.8,127.8 294,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.5,137.2 292.3,136.9 291.6,129 290.8,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "288.3,138.4 289.1,138.1 288.4,130.2 287.6,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.1,139.6 285.9,139.3 285.2,131.3 284.4,131.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "281.9,140.8 282.7,140.5 282,132.5 281.2,132.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "331.9,120.4 329.5,121.7 330.5,133.9 333,133.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "317.6,120.9 315.2,122.3 316.2,134.5 318.7,134.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "333,133.8 345.3,133.2 344.2,119.8 331.9,120.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "341,131.8 342,131.8 341.2,121.6 340.1,121.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "336,132.1 337.1,132 336.2,121.8 335.2,121.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "318.7,134.4 331,133.9 329.9,120.5 317.6,121  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "326.7,132.5 327.7,132.4 326.9,122.2 325.8,122.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "321.7,132.7 322.8,132.6 321.9,122.4 320.9,122.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "304.4,135.1 316.7,134.5 315.6,121.1 303.3,121.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "312.4,133.1 313.4,133.1 312.6,122.8 311.5,122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "307.4,133.3 308.5,133.3 307.6,123 306.6,123.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "333.1,134.5 330.7,135.9 331.7,148.1 334.2,147.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "318.8,135.1 316.4,136.4 317.4,148.6 319.9,148.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "334.2,147.9 346.5,147.4 345.4,133.9 333.1,134.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "342.2,146 343.2,145.9 342.4,135.7 341.3,135.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "337.2,146.2 338.3,146.1 337.4,135.9 336.4,135.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "319.9,148.5 332.2,148 331,134.6 318.8,135.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "327.8,146.6 328.9,146.5 328.1,136.3 327,136.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "322.9,146.8 324,146.8 323.1,136.5 322.1,136.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "305.6,149.2 317.9,148.6 316.8,135.2 304.5,135.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "313.6,147.2 314.6,147.2 313.8,136.9 312.7,137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.6,147.5 309.7,147.4 308.8,137.2 307.8,137.2  "
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "277.4,132.4 279.4,132.3 280.3,143.5 278.4,144.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "277.4,132.4 256.3,141.4 257.2,151.6 278.4,144.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.4,143.2 276.1,142.9 275.5,135.1 274.7,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.6,144.2 273.3,143.9 272.7,136.1 271.9,136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "269.8,145.2 270.5,145 269.9,137.1 269.1,137.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "267,146.2 267.7,146 267.1,138.1 266.3,138.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264.2,147.3 264.9,147 264.3,139.2 263.5,139.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "261.4,148.3 262.1,148 261.5,140.2 260.7,140.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "258.6,149.3 259.3,149.1 258.7,141.2 257.9,141.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "304.5,135.8 280.4,144 281.5,157.8 306,152.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "302.2,147.4 303,147.2 302.4,139.2 301.5,139.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "299,148.4 299.8,148.1 299.2,140.2 298.3,140.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.8,149.4 296.6,149.1 295.9,141.1 295.1,141.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "292.6,150.3 293.4,150.1 292.7,142.1 291.9,142.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "289.4,151.3 290.2,151.1 289.5,143.1 288.7,143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.1,152.3 287,152.1 286.3,144.1 285.5,144.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.9,153.3 283.8,153.1 283.1,145.1 282.3,145.3  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "278.4,144.6 280.4,144.7 281.6,158.2 279.6,158.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "278.4,144.6 257.3,152.3 258.1,162.5 279.5,157.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "276.4,155.2 277.2,155 276.5,147.2 275.7,147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "273.6,156.1 274.3,155.9 273.7,148 272.9,148.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "270.8,156.9 271.5,156.7 270.9,148.8 270.1,149.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "268,157.8 268.7,157.5 268,149.7 267.3,149.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "265.1,158.6 265.9,158.4 265.2,150.5 264.5,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,159.4 263.1,159.2 262.4,151.4 261.7,151.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "259.5,160.3 260.2,160.1 259.6,152.2 258.8,152.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250,182.7l82.6-8.3l5.7-12.9c0.7-1.6,1.8-3.1,3.1-4.2c5.4-4.7,19.1-18,3.2-18.8c0,0-14.3-2.2-49.3,9.8 c-0.5,0.2-0.9,0.5-1.1,1l-2.6,5.9c-0.2,0.4-0.5,0.7-1,0.8l-53.5,9.4c-0.7,0.1-1.1,0.9-0.8,1.5C238.1,170.8,244,183.3,250,182.7z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M345.8,138.6c-1.5,2.5-2.8,5-4,7.6c-1.3,2.6-2.4,5.2-3.4,7.9c-1,2.7-1.9,5.4-2.9,8.1 c-1,2.7-1.8,5.4-2.8,8.2l-0.1,0c0.3-2.9,0.9-5.7,1.7-8.5c0.8-2.8,1.9-5.5,3.1-8.1c2.3-5.3,5.1-10.4,8.3-15.2L345.8,138.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.5,174.8l93.8-10.5l2.5,0.6l-4.2,9.5l-82.6,8.3C250,182.7,245.2,184.2,240.5,174.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "251.3,117.8 264.4,117.4 264.7,120.8 260.2,122.7 256.3,122.8 251.6,120.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "334.2,118.9 333.8,119.1 333.4,118.9 333,120.3 336.6,120.2 335.2,119.6  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "319.3,119.1 319.8,119.3 320.2,119 320.7,120.4 317.1,120.5 318.4,119.8  "
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M339.5,75.1c0,0,7.1,2.7,2.1-8.4l0.7-0.2c0,0,5.8,7.3,3.7,13.1c-0.3,0.7-0.9,1.1-1.6,1.3 c-0.8,0.2-1.8,0.3-2.7,0.3c-0.4,0-0.9-0.1-1.3-0.1c-0.4-0.1-1.1-0.2-1.4-0.5C338.9,80.7,337.2,79.2,339.5,75.1z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,119.3 334.2,119.3 334.2,117.6 333.1,117.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "320.2,119.4 319.4,119.4 319.7,117.7 320.8,117.7  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.9,81.3c-0.6-0.9-1.3-1.8-2.2-2.4c-1.6-1.2-1.9-1.6-2.7,0c-2,4-1.7,7.9-0.3,10.9c1.2,2.5,3.2,4.5,5.4,6 c0.3,0.2,0.6,0.4,0.9,0.6c9.4,5.6,0,0,0,0l0.4-0.8c0,0-6.8-8.7-1.7-14L321.9,81.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.5,81.3l-1.1-6c0,0-0.4-0.7-4-2.2c-3.2-1.3-3.8-0.8-2.3,4.1c1.4,4.3,5.8,4.5,7.1,4.5 C341.4,81.7,341.5,81.5,341.5,81.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324,96.9l-0.6,1.2l-0.4-0.4c-0.2-0.2-0.3-0.6-0.2-0.9l0.4-1.3l0.3,0.1C324.1,95.8,324.3,96.5,324,96.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.4,91.6l-3.1,12l0.7-1c0-0.1,0.1-0.2,0.2-0.2l0.8-0.4c0.1-0.1,0.3,0,0.3,0.2l2.6,15.8 c0,0.1,0.1,0.2,0.2,0.2l1.1,0c0.1,0,0.2-0.1,0.2-0.2l1.4-17.4c0-1.6-0.2-3.1-0.5-4.7l-1.2-4.7L331.4,91.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.4,91.6l-2.1,10.3l-8.3,16.4c0,0-0.1,0.1-0.1,0.1l-1.1,0c-0.1,0-0.2-0.1-0.1-0.2l4.7-17.4 c0.3-2.3,1.1-4.4,2.3-6.3l1.5-2.5L331.4,91.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.9,118l-2.6-15.8c0-0.1-0.2-0.2-0.3-0.2l-0.9,0.4c-0.1,0-0.5,0.6-0.5,0.7c-0.1,0.4-0.6,1.2-0.8,1.7 c0,0,0.9-2.6,1.4-3.2c0,0,2.5-2.1,2.6,0.8L332.9,118z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M336.5,73.6c6.4,6.7,1.6,15.2,1.3,24.1c0,0.5-0.5,0.7-0.9,0.7l-11.4,0.3c-0.5,0-0.9-0.3-1-0.8 c-0.4-1.7-1.4-5.8-1.9-8.3c-1.4-7,0.3-15.6,1.2-16.3c0.3-0.2,1.5-0.4,1.9-0.4C327.7,72.6,334.7,71.6,336.5,73.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M336.5,73.6c6.4,6.7,1.6,15.2,1.3,24.1c0,0.5-0.5,0.7-0.9,0.7l-11.4,0.3c-0.5,0-0.9-0.3-1-0.8 c-0.4-1.7-1.4-5.8-1.9-8.3c-1.4-7,0.3-15.6,1.2-16.3c0.3-0.2,1.5-0.4,1.9-0.4C327.7,72.6,334.7,71.6,336.5,73.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.5,82.1c0.6-0.5,1.2-0.9,1.8-1.4c0.6-0.4,1.1-0.9,1.8-1.4c-0.2,0.8-0.8,1.4-1.4,1.9 C323,81.7,322.3,82,321.5,82.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M317.1,78.5l4.3,3.6c0,0,3.5-2.4,5-4.2c1.5-1.7-0.6-5.2-5-3.7C318.9,75.1,317.1,78.5,317.1,78.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M317,78.7l4.8,2.8c0,0,3.1-3,4.3-5s-1.3-5-5.5-2.8C318.2,75.1,317,78.7,317,78.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "rgb(204, 231, 249)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.3,72.5l-1.4,0.2l0.7,1.2c0.1,0.3,0.3,0.5,0.5,0.7l1.7,1.8l1.2-1.8l1.9,0.8l-0.3-1.6 c-0.1-0.3-0.1-0.6-0.3-0.8l-0.3-0.7l-0.4,0L328.3,72.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.9,74.7c-0.8,0.2-2.1-1.2-2.6-2.2c0-0.1,0.1-0.8,0.1-1.7c0-0.6,0.1-1.2,0.1-1.7l3.3,1 c0,0-0.3,1.2-0.3,2.2c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0C331.6,72.9,331.7,74.6,330.9,74.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.9,65.1c-0.1,1.3,1.4,4.8,2.4,5.4c1.4,0.9,3.4,0.6,4-1.2c0.5-1.7-1.4-6.2-2.5-6.7 C329.2,61.8,327,63.1,326.9,65.1z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326,65c0.1,0.8-0.4,1.8,0,2.4c0.4,0.6,1.1,1.3,1.8,1.5c0.3,0.1,0.3,0,0.4-0.1c0.4-0.4,0.1-1.6,0-2.1 c-0.2-0.6,0.5-1.1,1-0.7c0,0-0.2-0.5-0.2-0.5c0,0-0.8-2.2,2.8-1.5c0,0,0.4,0,0-0.5C331.5,63.1,326,65,326,65z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.1,74.8c0.6,1.6,1.1,3.3,1.5,5l0,0l0,0c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3-0.1-0.3-0.3 c0.2,0.2,0.5,0.2,0.7,0.1l0,0.1C331.9,78.2,331.4,76.5,331.1,74.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.1,76C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76 C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76 C331.1,76,331.1,76,331.1,76C331.1,76,331.1,76,331.1,76c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C331,76,331,76,331.1,76 c-0.1,0-0.1,0-0.1,0C331,76,331,76,331.1,76c-0.1,0-0.1,0-0.1,0C331,76,331,76,331.1,76c-0.1,0-0.1,0-0.1,0 C331,76,331,76,331.1,76c-0.1,0-0.1,0-0.1,0C331,76,331,76,331.1,76C331,76,331,76,331.1,76c-0.1,0-0.1,0-0.1,0 C331,76,331,76,331.1,76c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0.1,0C331,76,331.1,76,331.1,76 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0.1,0.1,0.2,0C331.1,76.2,331.1,76.1,331.1,76c0.1,0,0-0.1,0-0.1c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 C331.1,76.1,331.1,76.1,331.1,76C331.1,76.1,331.1,76.1,331.1,76L331.1,76z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.2,77.6,331.3,77.6C331.2,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.2,77.6,331.3,77.6 C331.2,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.2,77.6,331.3,77.6C331.2,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.2,77.6,331.3,77.6C331.2,77.6,331.2,77.6,331.3,77.6C331.2,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.2,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.6,331.3,77.6,331.3,77.6 C331.3,77.6,331.3,77.6,331.3,77.6C331.3,77.5,331.3,77.5,331.3,77.6C331.2,77.6,331.2,77.6,331.3,77.6 c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.1,0-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1 c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1C331.4,77.6,331.4,77.5,331.3,77.6C331.4,77.5,331.3,77.6,331.3,77.6L331.3,77.6z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.7,78.9c0,0,0-0.1,0-0.1C331.7,78.8,331.7,78.8,331.7,78.9C331.6,78.9,331.6,78.8,331.7,78.9 c-0.1,0-0.1,0-0.1,0C331.6,78.9,331.6,78.9,331.7,78.9c-0.1,0-0.1,0-0.1,0C331.6,78.9,331.6,78.9,331.7,78.9 c-0.1,0-0.1,0-0.1,0C331.6,78.8,331.6,78.9,331.7,78.9c-0.1,0-0.1,0-0.1,0C331.6,78.8,331.6,78.9,331.7,78.9 c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 C331.6,78.8,331.6,78.8,331.7,78.9c-0.1-0.1-0.1-0.1-0.1,0C331.6,78.8,331.6,78.8,331.7,78.9c-0.1-0.1-0.1-0.1-0.1-0.1 C331.6,78.8,331.6,78.8,331.7,78.9c-0.1-0.1-0.1-0.1-0.1-0.1C331.6,78.8,331.6,78.8,331.7,78.9c-0.1-0.1-0.1-0.1-0.1-0.1 C331.6,78.8,331.6,78.8,331.7,78.9C331.6,78.8,331.6,78.8,331.7,78.9C331.6,78.8,331.6,78.8,331.7,78.9 C331.6,78.8,331.6,78.8,331.7,78.9C331.6,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.6,78.8,331.7,78.9 C331.6,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9 C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9 C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9 C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9 C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9C331.7,78.8,331.6,78.8,331.7,78.9 C331.6,78.9,331.6,78.9,331.7,78.9C331.7,78.8,331.7,78.8,331.7,78.9c0-0.1,0-0.2,0-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0 C331.7,79,331.7,79,331.7,78.9C331.8,79,331.8,78.9,331.7,78.9C331.8,78.9,331.8,78.9,331.7,78.9 C331.8,78.9,331.8,78.9,331.7,78.9c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1C331.6,79,331.6,79,331.7,78.9C331.6,79,331.7,79,331.7,78.9 C331.7,78.9,331.7,78.9,331.7,78.9L331.7,78.9z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "340.4,66.1 333.7,66.7 333.6,65.6 340.2,64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "345.5,66 338.2,66.6 337.9,64.6 345.2,63.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "350.5,65.8 344.3,66.2 343.9,63.5 350,62.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M350.6,66.3L350.6,66.3c0.2,0,0.3-0.2,0.3-0.4l-0.5-3.5c0-0.2-0.2-0.4-0.4-0.3l0,0c-0.2,0-0.3,0.2-0.3,0.4 l0.5,3.5C350.3,66.1,350.4,66.3,350.6,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M333.7,66.9L333.7,66.9c-0.2,0-0.3-0.1-0.4-0.3l-0.1-0.9c0-0.2,0.1-0.3,0.3-0.4l0,0c0.2,0,0.3,0.1,0.4,0.3 l0.1,0.9C334,66.7,333.9,66.9,333.7,66.9z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.6,66.7c0,0-0.9-1.5-0.2-1.9c0.8-0.4,1.2-0.1,1.2,0.2c0.1,0.3-0.1,1.8-0.1,1.8L341.6,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.9,64.2c0,0,0.7,0.4,1.1,0.2c0.4-0.2,0.3-0.4,0.3-0.4S341.1,63.7,340.9,64.2z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,67.1l0.5,0.7c1.6-2.9,4.6-3.6,5.4-3.9c0.1,0,0.2-0.2,0.2-0.3c0-0.1,0-0.2,0-0.2 c-0.1-0.9-0.6-1.7-1.4-2.1c-0.8-0.5-2-0.7-3.3,0.3C325.8,62.7,324.9,65.2,325.9,67.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329,65c0,0-1.1-0.5-1.1,0.8c0,0-1.4-0.3-1,1.1c0,0-0.8,0.3-0.2,0.9c0.6,0.6,1.1-0.7,1.1-0.7l0.8-1.6L329,65z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.3,67.8c0,0-0.3,1.3,0.8,1c0,0,0.5,1,1.2,0c0,0,0.9-0.1,0.1-1.4c0,0,0.5-0.7-0.2-1 C327.4,66.2,326.3,67.8,326.3,67.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.7,66.8c0,0-0.6,0.2-0.2,0.7c0,0,0.5,0.9,0.8,0.3S325.7,66.8,325.7,66.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.8,67.7c-0.3,1.9-1.2,3-1.6,3.4c-0.1,0.1-0.2,0-0.2-0.1c-0.2-3.4,1.7-3.7,1.7-3.7L325.8,67.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,67.3c0,0-1.3,0.9-0.2,3.4c0,0.1,0.2,0.1,0.2,0c0.2-0.5,0.5-1.6,0.2-3.1L325.9,67.3z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.3,61.5c0.3,0,0.3-0.4,0-0.4C329,61.1,329,61.5,329.3,61.5L329.3,61.5z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.7,62.1c0.3,0,0.3-0.4,0-0.4C327.5,61.7,327.5,62.1,327.7,62.1L327.7,62.1z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.3,62.9c0.3,0,0.3-0.4,0-0.4C329,62.5,329,62.9,329.3,62.9L329.3,62.9z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328,63.9c0.3,0,0.3-0.4,0-0.4C327.7,63.5,327.7,63.9,328,63.9L328,63.9z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.9,63.5c0.3,0,0.3-0.4,0-0.4C326.7,63.1,326.7,63.5,326.9,63.5L326.9,63.5z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.2,64.2c0.3,0,0.3-0.4,0-0.4C330,63.8,330,64.2,330.2,64.2L330.2,64.2z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331,62.4c0.3,0,0.3-0.4,0-0.4C330.8,62,330.8,62.4,331,62.4L331,62.4z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.5,65.4c0.3,0,0.3-0.4,0-0.4C327.2,65,327.2,65.4,327.5,65.4L327.5,65.4z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325.9,65.1c0.3,0,0.3-0.4,0-0.4C325.6,64.7,325.6,65.1,325.9,65.1L325.9,65.1z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.1,66.6c0.3,0,0.3-0.4,0-0.4C325.8,66.2,325.8,66.6,326.1,66.6L326.1,66.6z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325.6,68.8c0.3,0,0.3-0.4,0-0.4C325.3,68.4,325.3,68.8,325.6,68.8L325.6,68.8z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.8,68.6c0.3,0,0.3-0.4,0-0.4C324.6,68.2,324.6,68.6,324.8,68.6L324.8,68.6z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.7,69.8c0.3,0,0.3-0.4,0-0.4C324.4,69.4,324.4,69.8,324.7,69.8L324.7,69.8z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.3,70.8c0.3,0,0.3-0.4,0-0.4C324,70.4,324,70.8,324.3,70.8L324.3,70.8z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326,69.8c0.3,0,0.3-0.4,0-0.4C325.7,69.4,325.7,69.8,326,69.8L326,69.8z"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.7,66.8c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c-0.1-0.1-0.2-0.2-0.3-0.3 C326,66.9,325.9,66.9,325.7,66.8z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.6,67.4c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1 c-0.1,0.1-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c0-0.1-0.1-0.1-0.1-0.2C325.6,67.6,325.6,67.4,325.6,67.4z"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1061,187.9c0,0-195.3-83.1-342-17.8s-114.6-64.6-361.5-5.3S1.3,120.6,1.3,120.6v147.3H1061V187.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 530.5,
    y1: 270.5606,
    x2: 530.5,
    y2: 183.4943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "rgb(255, 255, 255)",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 169.7,
    className: "st13",
    width: 1061,
    height: 105.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.8402,
    y1: 672.2929,
    x2: 373.8402,
    y2: 560.35,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 390.6064 520.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 255, 255)",
      stopOpacity: 0
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "922.2,29.1 922.2,264.5 1061,264.5 1061,29.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.8402,
    y1: -119.0764,
    x2: 373.8402,
    y2: -223.7548,
    gradientTransform: "matrix(4.489653e-11 -1 -1 -4.489653e-11 -120.8524 520.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 255, 255)",
      stopOpacity: 0
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "129.8,29.1 129.8,264.5 0,264.5 0,29.1  "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShipOnTheSea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ship-on-the-sea.085e5598.svg";
export { ForwardRef as ReactComponent };